import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';
import type { RootState } from 'store';
import { handleQueryError } from 'store/utils';

import { publicEventsReportApi } from './publicEventsReportApi';

// TODO extract effects in next iteration
export const publicEventsReportApiLister = createListenerMiddleware<RootState>();

publicEventsReportApiLister.startListening({
  matcher: isAnyOf(
    publicEventsReportApi.endpoints.getPublicEventsReportById.matchRejected,
    publicEventsReportApi.endpoints.getPublicEventsReportKeyMetrics.matchRejected,
    publicEventsReportApi.endpoints.getPublicEventsReportDemographics.matchRejected,
    publicEventsReportApi.endpoints.getPublicEventsReportAnswers.matchRejected
  ),
  effect: ({ payload, type }, { dispatch }) => {
    handleQueryError(payload, dispatch, type, "Unable to fetch Events Report's data");
  },
});
